import $http from '../http'
import { baseUrl } from '../url'
const BASEURL = baseUrl.primary + '/v2'
const NEWBASEURL = baseUrl.primary + '/v3'
const BASEURL_DEV = BASEURL + '/User'
const NEWBASEURL_DEV = NEWBASEURL + '/user'

const user = {
 AffirmWeChatReplacePay(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/Company/AffirmWeChatReplacePay`,
      data
    })
  },
  BomPage(params) {
    return $http({
      method: 'get',
      url: `${NEWBASEURL_DEV}/Bom/BomPage`,
      params
    })
  },
 BomInfo(params) {
  return $http({
    method: 'get',
    url: `${NEWBASEURL_DEV}/Bom/BomInfo`,
    params
  })
  },
  BomUserList(params) {
    return $http({
      method: 'get',
      url: `${NEWBASEURL_DEV}/Bom/BomUserList`,
      params
    })
  },
  BomAdd(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/Bom/BomAdd`,
      data
    })
  },
  GenerateAppintmenttEmail(params) {
    return $http({
      method: 'get',
      url: `${NEWBASEURL_DEV}/CompanyReferrerCar/GenerateAppintmenttEmail`,
      params
    })
  },
  PersonageAuthentication(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/Company/PersonageAuthentication`,
      data
    })
  },
  ReferrerCardBatchPage(params) {
    return $http({
      method: 'get',
      url: `${NEWBASEURL_DEV}/CompanyReferrerCar/ReferrerCardBatchPage`,
      params
    })
  },
  CardCppointment(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/CompanyReferrerCar/CardCppointment`,
      data
    })
  },
  LoginByWeChatScanQRcode(params) {
    return $http({
      method: 'get',
      url: `${NEWBASEURL_DEV}/CompanyManageUser/LoginByWeChatScanQRcode`,
      params
    })
  },
  CompanyGetDetail(params) {
    return $http({
      method: 'get',
      url: `${NEWBASEURL_DEV}/Company/GetDetail`,
      params
    })
  },
  RegisterIndividualAccount(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/Company/RegisterIndividualAccount`,
      data
    })

  },
  RequestUserOpenId(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/RequestUserOpenId`,
      data
    })
  },
  OneselfFieldChange(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/Company/OneselfFieldChange`,
      data
    })
  },
  BatchAdd(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/CompanyUserList/BatchAdd`,
      data
    })
  },
  UpdatePassword(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/CompanyManageUser/UpdatePassword`,
      data
    })
  },
  RetrievePassword(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/CompanyManageUser/RetrievePassword`,
      data
    })
  },
  ForgetPasswod(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/CompanyManageUser/ForgetPasswod`,
      data
    })
  },
  LoginByNoteVerificationCode(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/CompanyManageUser/LoginByNoteVerificationCode`,
      data
    })
  },
  SendSms(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/SendSms`,
      data
    })
  },
  UserOnJobRecordDelete(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/UserOnJobRecord/Delete`,
      data
    })
  },
  UserOnJobRecordEdit(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/UserOnJobRecord/Edit`,
      data
    })
  },
  UserOnJobRecordDetail(params) {
    return $http({
      method: 'get',
      url: `${NEWBASEURL_DEV}/UserOnJobRecord/Detail`,
      params
    })
  },
  UpdateDefaultBankInfo(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/CompanyUserList/UpdateDefaultBankInfo`,
      data
    })
  },
  InfoStatistics(params) {
    return $http({
      method: 'get',
      url: `${NEWBASEURL_DEV}/InfoStatistics`,
      params
    })
  },
  CompanyUserStateStatisticsData(params) {
    return $http({
      method: 'get',
      url: `${NEWBASEURL_DEV}/CompanyUserList/CompanyUserStateStatisticsData`,
      params
    })
  },
  IndividualAccountAuthentication(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/Company/IndividualAccountAuthentication`,
      data
    })
  },
  CompanyReferrerCarSyncBankCardStatu(params) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/CompanyReferrerCar/SyncBankCardStatu`,
      params
    })
  },
  CompanyManageUserGetInfoPartial(params) {
    return $http({
      method: 'get',
      url: `${NEWBASEURL_DEV}/CompanyManageUser/GetInfoPartial`,
      params
    })
  },
  Logout(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/UserCard/Logout`,
      data
    })
  },
  CompanyManageUserDelete(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/CompanyManageUser/Delete`,
      data
    })
  },
  CompanyManageUserResetPassword(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/CompanyManageUser/ResetPassword`,
      data
    })
  },
  CompanyManageUserEdit(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/CompanyManageUser/Edit`,
      data
    })
  },
  CompanyManageUserPage(params) {
    return $http({
      method: 'get',
      url: `${NEWBASEURL_DEV}/CompanyManageUser/Page`,
      params
    })
  },
  CompanyReferrerCarSendMsgAgain(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/CompanyReferrerCar/SendMsgAgain`,
      data
    })
  },
  CompanyReferrerCarRefreshState(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/CompanyReferrerCar/RefreshState`,
      data
    })
  },
  CompanyUserListQRCodeEnter(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/CompanyUserList/QRCodeEnter`,
      data
    })
  },
  CompanyUserListBatchUpdateSata(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/CompanyUserList/BatchUpdateSata`,
      data
    })
  },
  CompanyReferrerCarSetOpenCarState(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/CompanyReferrerCar/SetOpenCarState`,
      data
    })
  },
  CompanyCancelAuthentication(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/Company/CancelAuthentication`,
      data
    })
  },
  CompanySubmitAuthentication(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/Company/SubmitAuthentication`,
      data
    })
  },
  CompanyReferrerCardStatePage(params) {
    return $http({
      method: 'get',
      url: `${NEWBASEURL_DEV}/CompanyReferrerCar/StatePage`,
      params
    })
  },
  CardFollowStateList(params) {
    return $http({
      method: 'get',
      url: `${NEWBASEURL_DEV}/CompanyReferrerCar/CardFollowStateList`,
      params
    })
  },
  CompanyReferrerCarPage(params) {
    return $http({
      method: 'get',
      url: `${NEWBASEURL_DEV}/CompanyReferrerCar/Page`,
      params
    })
  },
  CompanyReferrerCarPageAll(params) {
    return $http({
      method: 'get',
      url: `${NEWBASEURL_DEV}/CompanyReferrerCar/PageAll`,
      params
    })
  },
  CompanyReferrerCarAdd(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/CompanyReferrerCar/Add`,
      data
    })
  },
  CompanyEditCompanyInfo(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/Company/EditCompanyInfo`,
      data
    })
  },
  CompanyManageUserEdit(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/CompanyManageUser/Edit`,
      data
    })
  },
  CompanyUserListDetail(params) {
    return $http({
      method: 'get',
      url: `${NEWBASEURL_DEV}/CompanyUserList/Detail`,
      params
    })
  },
  CompanyUserLisBatchUpdateSata(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/Company/EditAndSubmit`,
      data
    })
  },
  EditAndSubmit(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/Company/EditAndSubmit`,
      data
    })
  },
  UserCardSetDefault(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/UserCard/SetDefault`,
      data
    })
  },
  CompanyEdit(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/Company/Edit`,
      data
    })
  },
  CompanyUserListEdit(data) {
    return $http({
      method: 'get',
      url: `${NEWBASEURL_DEV}/Company/Detail`,
      data
    })
  },
  CompanyDetail() {
    return $http({
      method: 'get',
      url: `${NEWBASEURL_DEV}/Company/Detail
      `
    })
  },
  GetCompanyManageUserInfo() {
    return $http({
      method: 'get',
      url: `${NEWBASEURL_DEV}/CompanyManageUser/GetCompanyManageUserInfo`
    })
  },
  GetLoginToken(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/CompanyManageUser/GetLoginToken`,
      data
    })
  },
  CompanyUserLogin(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/CompanyManageUser/CompanyUserLogin`,
      data
    })
  },
  UserOnJobRecordPage(params) {
    return $http({
      method: 'get',
      url: `${NEWBASEURL_DEV}/UserOnJobRecord/Page`,
      params
    })
  },
  ImportUserData(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/CompanyUserList/ImportUserData`,
      data
    })
  },
  CompanyUserListBatchDelete(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/CompanyUserList/BatchDelete`,
      data
    })
  },
  CompanyUserListEdit(data) {
    return $http({
      method: 'post',
      url: `${NEWBASEURL_DEV}/CompanyUserList/Edit`,
      data
    })
  },
  CompanyUserListPage(params) {
    return $http({
      method: 'get',
      url: `${NEWBASEURL_DEV}/CompanyUserList/Page`,
      params
    })
  },
  UserCardDelete(params) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/UserCardDelete`,
      params
    })
  },
  // SetOpenCarState(data) {
  //   return $http({
  //     method: 'post',
  //     url: `${BASEURL_DEV}/SetOpenCarState`,
  //     data
  //   })
  // },
  //导出已发放
  UserBonusByBrokerIsPayExport(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/UserBonusByBrokerIsPayExport`,
      params,
      responseType: 'blob'
    })
  },
  //导出待发放
  UserBonusByBrokerWaitToPayExport(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/UserBonusByBrokerWaitToPayExport`,
      params,
      responseType: 'blob'
    })
  },
  //报名记录
  UserApplyByUserPage(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/UserApplyByUserPage`,
      params
    })
  },
  //导入用户状态表
  ImportFileToUpdateState(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/ImportFileToUpdateState`,
      data
    })
  },
  //导入工资表
  ImportWaitCalculateData(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/ImportWaitCalculateData`,
      data
    })
  },
  //确认资料
  EditMaterialState(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/EditMaterialState`,
      data
    })
  },
  //职位统计
  PositionStatisticsData(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/PositionStatisticsData`,
      params
    })
  },
  //单位统计
  FactoryStatisticsData(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/FactoryStatisticsData`,
      params
    })
  },
  BonusByRefererStatisticsData(year) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/BonusByRefererStatisticsData?year=${year}`
    })
  },
  BonusByBrokerStatisticsData(year) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/BonusByBrokerStatisticsData?year=${year}`
    })
  },
  ApplyStatisticsData(year) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/ApplyStatisticsData?year=${year}`
    })
  },
  BrokerStatisticsData(year) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/BrokerStatisticsData?year=${year}`
    })
  },
  RefererStatisticsData(year) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/RefererStatisticsData?year=${year}`
    })
  },
  Del(id) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/Del?uid=${id}`
    })
  },
  UpdateDelete(id) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/UpdateDelete?id=${id}`
    })
  },
  // 推荐人奖金来源
  ReferrerBonusDetail(id) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/ReferrerBonusDetail?id=${id}`
    })
  },
  // 经纪人待发放奖金来源
  UserBonusSource(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/UserBonusSource`,
      params
    })
  },
  ReferrerBonusPage(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/ReferrerBonusPage`,
      params
    })
  },

  // 待计算新增人员
  UserBonusByBrokerDetailAdd(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/UserBonusByBrokerDetailAdd`,
      data
    })
  },
  // 更新金额
  UserBonusByBrokerDetailEdit(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/UserBonusByBrokerDetailEdit`,
      data
    })
  },
  // 待发放批量确认
  BatchUpdateState(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/BatchUpdateState`,
      data
    })
  },
  // 待确认批量删除
  BatchDeleteBrokerDetail(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/BatchDeleteBrokerDetail`,
      data
    })
  },
  // 待确认批量确认
  BatchNotarizeBrokerDetail(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/BatchNotarizeBrokerDetail`,
      data
    })
  },
  IsPayPage(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/IsPayPage`,
      params
    })
  },
  UserBonusByBrokerPage(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/UserBonusByBrokerPage`,
      params
    })
  },
  UserApplyDetail(id) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/UserApplyDetail?id=${id}`
    })
  },
  UserBonusByBrokerDetailPage(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/UserBonusByBrokerDetailPage`,
      params
    })
  },
  ResidentPlantUpdateState(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/ResidentPlantUpdateState`,
      data
    })
  },
  RemoveUserQualification(id) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/RemoveUserQualification?userId=${id}`
    })
  },
  UserAdd(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/UserAdd`,
      data
    })
  },
  GetUserListByKeyWord(keyWord) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/GetUserListByKeyWord?topNum=50&keyWord=${keyWord}`
    })
  },
  ResidentPlantFollowPage(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/ResidentPlantFollowPage`,
      params
    })
  },
  UserApplyFollowEdit(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/UserApplyFollowEdit`,
      data
    })
  },
  BatchApply(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/BatchApply`,
      data
    })
  },
  ToReferrerAuditEdit(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/ToReferrerAuditEdit`,
      data
    })
  },
  ToBrokerAuditEdit(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/ToBrokerAuditEdit`,
      data
    })
  },
  DimissionBrokerAuditEdit(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/DimissionBrokerAuditEdit`,
      data
    })
  },
  BrokerAuditEdit(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/BrokerAuditEdit`,
      data
    })
  },
  ReferrerAuditEdit(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/ReferrerAuditEdit`,
      data
    })
  },
  ToReferrerAuditPage(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/ToReferrerAuditPage`,
      params
    })
  },
  ToBrokerAuditPage(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/ToBrokerAuditPage`,
      params
    })
  },
  DimissionBrokerAuditPage(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/DimissionBrokerAuditPage`,
      params
    })
  },
  ReferrerAuditPage(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/ReferrerAuditPage`,
      params
    })
  },
  BrokerAuditPage(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/BrokerAuditPage`,
      params
    })
  },
  getVierificationCode() {
    return $http({
      method: 'get',
      url: `${NEWBASEURL_DEV}/getVierificationCode`
    })
  },
  login(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/login`,
      data
    })
  },

  userOnJob(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/UserOnJobPage`,
      params
    })
  },

  Useritems(id) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/UserApplyOnJobDetail/?id=${id}`
    })
  },

  UserPage(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/UserPage`,
      params
    })
  },
  UserApplyPage(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/UserApplyPage_Company`,
      params
    })
  },

  UserApplyPage2(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/UserApplyPage`,
      params
    })
  },

  UserApplyOnAllocationPage(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/UserApplyOnAllocationPage`,
      params
    })
  },

  UserApplyFollowPage(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/UserApplyFollowPage`,
      params
    })
  },

  UserCardPage(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/CardPage`,
      params
    })
  },

  UserCardDetail(id) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/CardDetail?id=${id}`
    })
  },

  UserCardEdit(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/CardEdit`,
      data
    })
  },

  UserDetail(id) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/UserDetail?userId=${id}`
    })
  },

  ApplyUserInfo(id) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/ApplyUserInfo?userId=${id}`
    })
  },

  UserApplyEdit(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/UserApplyEdit`,
      data
    })
  },

  ServiceFollowPage(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/ServiceFollowPage`,
      params
    })
  },

  ServiceFollowEdit(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/ServiceFollowEdit`,
      data
    })
  },

  UserEdit(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/UserEdit`,
      data
    })
  },

  UserApplyDel(id) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/UserApplyDel?id=${id}`
    })
  },

  UserChildishPage(id) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/UserChildishPage?userId=${id}`
    })
  },

  UserChildishPage2(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/UserChildishPage`,
      params
    })
  },

  register(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/register`,
      data
    })
  },
  changePassword(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/User/ModifyPwd`,
      data
    })
  },
  getUserInfo(memberId) {
    return $http({
      method: 'get',
      url: `${BASEURL}/User/items/${memberId}`
    })
  },

  UserListByRole(Id) {
    return $http({
      method: 'get',
      url: `${BASEURL}/User/UserListByRole?roleId=${Id}`
    })
  },
  editUser(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/User/edit`,
      data
    })
  },
  getUserList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL}/User/Items`,
      params
    })
  },
  getAllUser(menuId) {
    var mid = menuId || 0
    return $http({
      method: 'get',
      url: `${BASEURL}/User/Childs?menuId=${mid}`
    })
  },
  deleteUser(id) {
    return $http({
      method: 'post',
      url: `${BASEURL}/User/del?uid=${id}`
    })
  },
  getSetTeamUser(bool = false) {
    return $http({
      method: 'get',
      url: `${BASEURL}/User/ItemsByNoParentAndDept?isSet=${bool}`
    })
  },
  setTeamMembers(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/User/SetParentOrDept`,
      data
    })
  },
  removeTeamMembers(id) {
    return $http({
      method: 'post',
      url: `${BASEURL}/User/RemoveParentAndDept?uid=${id}`
    })
  },
  createTeam(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/User/Department/edit`,
      data
    })
  },
  deleteTeam(id) {
    return $http({
      method: 'post',
      url: `${BASEURL}/User/Department/del?id=${id}`
    })
  },
  getTeamList() {
    return $http({
      method: 'get',
      url: `${BASEURL}/User/Department/Items`
    })
  },
  getUserCompanyInfo(id) {
    return $http({
      method: 'get',
      url: `${BASEURL}/User/Company/items/${id}`
    })
  },
  editCompanyInfo(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/User/Company/edit`,
      data
    })
  },
  getRightsMenus(id = '',flag = 'woyou1') {
    return $http({
      method: 'get',
      url: `${NEWBASEURL_DEV}/GetCompanyUserAuthMenus?menuId=${id}&flag=${flag}`
    })
  },
  getHistoricalOrders() {
    return $http({
      method: 'get',
      url: `${BASEURL}/Main/Order/ServeSetMealPage`
    })
  },
  sendRegisterSms(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/RegisterSendSms`,
      data
    })
  },
  accountExists(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/AccountExists`,
      data
    })
  },
  findPassword(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/AccountPwdReset`,
      data
    })
  },
  getCompanyIsVip() {
    return $http({
      method: 'get',
      url: `${BASEURL}/User/Company/IsVip`
    })
  },
  getCompanyIsAllowDownload() {
    return $http({
      method: 'get',
      url: `${BASEURL}/User/Company/DownloadResumeCheck`
    })
  },
  deductResumeDownloadCnt() {
    return $http({
      method: 'post',
      url: `${BASEURL}/User/Company/DownloadResumeDeduct`
    })
  }
}

export default user
